export const BD_ADMIN_PERMISSION_STORAGE_BUCKET =
  'bd.config.BD_ADMIN_PERMISSIONS';

/**
 * Admin permissions returned by `GET /admin/permissions/`.
 *
 * `ADMIN:GOD` is expanded server-side to include the sub-permissions
 * (FEATURE, SHAREABLES, USER, COMPANY, JOBS) so consumers only need to check the
 * specific permission they require. The backend no longer grants `ADMIN:GROUPS`.
 */
export type BdAdminPermission =
  | 'ADMIN:GOD'
  | 'ADMIN:FEATURE'
  | 'ADMIN:SHAREABLES'
  | 'ADMIN:GROUPS'
  | 'ADMIN:USER'
  | 'ADMIN:COMPANY'
  | 'ADMIN:JOBS';

export const BD_ADMIN_PERMISSION = {
  GOD: 'ADMIN:GOD',
  FEATURE: 'ADMIN:FEATURE',
  SHAREABLES: 'ADMIN:SHAREABLES',
  GROUPS: 'ADMIN:GROUPS',
  USER: 'ADMIN:USER',
  COMPANY: 'ADMIN:COMPANY',
  /** Job-status admin surface `/jobs/admin/*` (BDA-6736). */
  JOBS: 'ADMIN:JOBS',
} as const satisfies Record<string, BdAdminPermission>;
